import * as styles from "./ScrollAreaScrollbar.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { ScrollArea as BaseScrollArea } from "@base-ui/react/scroll-area";

import type { ScrollAreaScrollbarProps } from "./ScrollArea.types";

export function ScrollAreaScrollbar({
  className,
  orientation = "vertical",
  expandOnHover,
  alwaysVisible,
  ...props
}: ScrollAreaScrollbarProps): JSX.Element {
  return (
    <BaseScrollArea.Scrollbar
      data-slot="scroll-area-scrollbar"
      className={clsx(
        styles.scrollbar({ alwaysVisible }),
        expandOnHover && styles.expandOnHover,
        className,
      )}
      orientation={orientation}
      {...props}
    />
  );
}
